import React from 'react';
import {TextField, Loading, File} from 'components/form';
import {required, validationWrapper} from 'lib/formValidations';
import {Formik, Field, Form} from 'formik';
import {useGallery} from 'store/gallery'

export default function Add(props) {
   const {submittAddFile, dispatch, current_collection, getCollections} = useGallery();
   return (
      <div className="flex w-full flex-col  pt-3 px-16">
         <div className="flex w-full justify-between items-center h-5 mb-3">
            <h2 className="">افزودن فایل</h2>
            <button type="button" onClick={props.handleBack}
                    className="w-full inline-flex justify-center bg-theme-8 rounded border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium  focus:outline-none  focus:ring-2 focus:ring-offset-2 sm:mt-0 sm:w-auto sm:text-sm">
               <span>بازگشت</span>
            </button>
         </div>

         <Formik
            initialValues={{name: '', collection_name: current_collection}}
            onSubmit={async (values, {setSubmitting}) => {
               await dispatch(submittAddFile({...values}, () => {
                  props.handleBack();
                  dispatch(getCollections());
               }));
               setSubmitting(false);
            }}
         >
            {({isSubmitting, setFieldValue}) => (
               <Form>
                  <div className="flex w-full justify-between	">
                     <div className="w-6/12">
                        <Field
                           label="فایل"
                           name="image"
                           component={File}
                           type="file"
                           setFieldValue={setFieldValue}
                        />
                     </div>
                     <div className="w-5/12">
                        <Field
                           label="عنوان"
                           name="name"
                           component={TextField}
                           validate={(value) => validationWrapper(value, required)}
                        />
                        <Field
                           label="دسته بندی"
                           name="collection_name"
                           component={TextField}
                           validate={(value) => validationWrapper(value, required)}
                        />
                     </div>
                  </div>
                  <div className="w-full flex justify-center">
                     <button
                        className="mt-8 rounded bg-green-500 text-sm font-bold t px-6 py-3 shadow outline-none focus:outline-none mb-1 bg-theme-9 text-white"
                        type="submit"
                        style={{transition: 'all 0.15s ease 0s'}}
                        disabled={isSubmitting}
                     >
                        {isSubmitting ? <Loading/> : 'آپلود'}
                     </button>
                  </div>
               </Form>
            )}
         </Formik>
      </div>
   );
}
